/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CustomerSegmentEnum = 'ACADEMIC' | 'COMMERCIAL' | 'GOVERNMENT';

export const CustomerSegmentEnum = {

    ACADEMIC: 'ACADEMIC' as CustomerSegmentEnum,

    COMMERCIAL: 'COMMERCIAL' as CustomerSegmentEnum,

    GOVERNMENT: 'GOVERNMENT' as CustomerSegmentEnum
};

